// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__2SUMP","content":"Loading_content__1ownL","text":"Loading_text__33fcG"};